import { Link } from "react-router-dom";
import { getRoutePaths, useLang } from "../../../utils/i18n";
import "./NotFound.css";

const COPY = {
  en: {
    kicker: "Error 404",
    title: "This page has wandered off",
    message:
      "The page you're looking for doesn't exist or may have been moved. Let's get you back on track.",
    primaryCta: "Back to home",
    secondaryCta: "Explore our services",
    langSwitch: "Ler esta página em português",
  },
  pt: {
    kicker: "Erro 404",
    title: "Esta página não foi encontrada",
    message:
      "A página que você procura não existe ou pode ter sido movida. Vamos te levar de volta ao caminho certo.",
    primaryCta: "Voltar para início",
    secondaryCta: "Conhecer nossos serviços",
    langSwitch: "Read this page in English",
  },
};

const NotFound = () => {
  const lang = useLang();
  const copy = COPY[lang] || COPY.en;
  const paths = getRoutePaths(lang);
  const otherLang = lang === "en" ? "pt" : "en";
  const otherLangHome = getRoutePaths(otherLang).home;

  return (
    <section className="not-found-page" aria-label="404 page not found">
      <div className="not-found-content">
        <p className="not-found-eyebrow">{copy.kicker}</p>
        <p className="not-found-code" aria-hidden="true">404</p>
        <span className="not-found-divider" aria-hidden="true" />
        <h1 className="not-found-title">{copy.title}</h1>
        <p className="not-found-message">{copy.message}</p>
        <div className="not-found-actions">
          <Link className="not-found-action not-found-action-primary" to={paths.home}>
            {copy.primaryCta}
          </Link>
          <Link className="not-found-action not-found-action-secondary" to={paths.services}>
            {copy.secondaryCta}
          </Link>
        </div>
        <Link className="not-found-lang-switch" to={otherLangHome}>
          {copy.langSwitch}
        </Link>
      </div>
    </section>
  );
};

export default NotFound;
